<script>
	import { toast } from "@zerodevx/svelte-toast";
	import { SvelteToast } from "@zerodevx/svelte-toast";

	let style;

	$: style = "--toastContainerLeft:" + (window.innerWidth / 2 + 240) + "px;";

	const notify = () => {
		toast.push(
			`<strong>You won the jackpot!</strong><br>Click <a href="#">here</a> for details! 😛`,
			{
				target: 'myNewContainer',
				next: 0,
				dismissable: true,
				duration: 10000,
				pausable: true,
				theme: {
					// "--toastBackground": "#48BB78",
					// "--toastBarBackground": "#2F855A",
				},
			}
		);
	};
	// notify();

	const notifyRecur = () => {
		style = "--toastContainerLeft:" + (window.innerWidth / 2 + 300) + "px;";
		let waitTime = Math.random() * 5000;
		setTimeout(notifyRecur, waitTime);
		notify();
	}
	// notifyRecur();
	
</script>

<div class='annoy' style={style}>
	<SvelteToast target="myNewContainer"/>
</div>


<style>
	.annoy {
		--toastContainerTop: 5rem;
		--toastContainerBottom: auto;
	}
</style>
